(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["gift-card-recipient-form"] && !Shopify.designMode) return;
  try {
    (() => {
    const root = document.querySelector('[data-gc-recipient-root]');
    if (!root) return;

    const toggle = root.querySelector('[data-gc-recipient-toggle]');
    const emailInput = root.querySelector('[data-gc-recipient-email]');
    const emailError = root.querySelector('[data-gc-recipient-email-error]');
    const messageInput = root.querySelector('[data-gc-recipient-message]');
    const sendOnInput = root.querySelector('[data-gc-recipient-send-on]');
    const sendOnFormatted = root.querySelector('[data-gc-recipient-send-on-formatted]');
    const offsetInput = root.querySelector('[data-gc-recipient-offset]');

    if (offsetInput) {
      offsetInput.value = new Date().getTimezoneOffset().toString();
    }

    if (sendOnInput) {
      const today = new Date();
      const yyyy = today.getFullYear();
      const mm = String(today.getMonth() + 1).padStart(2, '0');
      const dd = String(today.getDate()).padStart(2, '0');
      sendOnInput.min = `${yyyy}-${mm}-${dd}`;
    }

    const formatSendOnDate = () => {
      if (!sendOnInput || !sendOnFormatted) return;
      const dateValue = sendOnInput.value;
      if (dateValue) {
        sendOnFormatted.value = dateValue;
      } else {
        sendOnFormatted.value = '';
      }
    };

    if (sendOnInput) {
      sendOnInput.addEventListener('change', formatSendOnDate);
      formatSendOnDate();
    }

    if (!toggle || !emailInput) return;

    const emailRequiredMessage = root.dataset.gcRecipientEmailRequired || '';
    const emailInvalidMessage = root.dataset.gcRecipientEmailInvalid || '';

    let hasTyped = false;

    const updateState = () => {
      const enabled = toggle.checked;
      emailInput.toggleAttribute('required', enabled);
    };

    const validateEmail = () => {
      if (!toggle.checked) {
        emailInput.removeAttribute('aria-invalid');
        if (emailError) {
          emailError.hidden = true;
          emailError.textContent = '';
        }
        return true;
      }

      const value = emailInput.value.trim();
      if (!value) {
        emailInput.setAttribute('aria-invalid', 'true');
        if (emailError) {
          emailError.hidden = false;
          emailError.textContent = emailRequiredMessage || 'Email is required.';
        }
        return false;
      }

      const valid = emailInput.checkValidity();
      emailInput.setAttribute('aria-invalid', String(!valid));
      if (emailError) {
        emailError.hidden = valid;
        emailError.textContent = valid
          ? ''
          : (emailInvalidMessage || 'Enter a valid email address.');
      }
      return valid;
    };

    emailInput.addEventListener('input', () => {
      if (!hasTyped && emailInput.value.trim() !== '') {
        hasTyped = true;
        if (!toggle.checked) {
          toggle.checked = true;
          updateState();
          validateEmail();
        }
      }
    });

    if (messageInput) {
      messageInput.addEventListener('input', () => {
        if (!hasTyped && messageInput.value.trim() !== '') {
          hasTyped = true;
          if (!toggle.checked) {
            toggle.checked = true;
            updateState();
            validateEmail();
          }
        }
      });
    }

    toggle.addEventListener('change', () => {
      updateState();
      if (toggle.checked) {
        validateEmail();
      } else if (emailError) {
        emailError.hidden = true;
        emailError.textContent = '';
        emailInput.removeAttribute('aria-invalid');
      }
    });

    emailInput.addEventListener('blur', validateEmail);

    const form = root.closest('form');
    if (form) {
      form.addEventListener('submit', (event) => {
        if (!validateEmail()) {
          event.preventDefault();
          emailInput.focus();
        }
      });
    }

    updateState();
  })();
  } catch(e) { console.error(e); }
})();

})();
